//获取url中的参数
function getQueryString(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return unescape(r[2]);
    return null;
}

function judgeDataIsEmpty(data) {
    if (data === undefined || data === null) {
        return false
    }
    if (Object.prototype.toString.call(data) === '[object Object]' && data == {}) {
        return false
    }
    if (Object.prototype.toString.call(data) === '[object Array]' && data == []) {
        return false
    }
    if (Object.prototype.toString.call(data) === '[object String]' && data == "") {
        return false
    }
    return true

}

function timestampToTime(cjsj) {
    var date = new Date(cjsj) //时间戳为10位需*1000，时间戳为13位的话不需乘1000
    var Y = date.getFullYear() + '-'
    var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-'
    var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' '
    var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':'
    var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':'
    var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds())
    return Y + M + D + h + m + s;
}

/**
 * 为 js 中的 Date 对象原型添加 format 格式化方法
 * @param date 要进行格式化的日期
 * @param fmt 日期的格式
 * @returns 格式化得到的结果
 */
function dateFormat(date, fmt) {
    const o = {
        'y+': date.getFullYear(),
        'M+': date.getMonth() + 1,
        'd+': date.getDate(),
        'h+': date.getHours(),
        'm+': date.getMinutes(),
        's+': date.getSeconds(),
        'q+': Math.floor((date.getMonth() + 3) / 3),
        'S+': date.getMilliseconds(),
    };
    for (const k in o) {
        if (!new RegExp('(' + k + ')').test(fmt)) {
            continue;
        }
        if (k === 'y+') {
            fmt = fmt.replace(RegExp.$1, ('' + o[k]).substr(4 - RegExp.$1.length));
        } else if (k === 'S+') {
            let lens = RegExp.$1.length;
            lens = lens === 1 ? 3 : lens;
            fmt = fmt.replace(RegExp.$1, ('00' + o[k]).substr(('' + o[k]).length - 1, lens));
        } else {
            const v = Reflect.get(o, k);
            fmt = fmt.replace(RegExp.$1, RegExp.$1.length === 1 ? v : ('00' + v).substr(('' + v).length));
        }
    }
    return fmt;
}

const formatTime = (date, type) => {
    const year = date.getFullYear()
    const month = date.getMonth() + 1
    const day = date.getDate()
    const hour = date.getHours()
    const minute = date.getMinutes()
    const second = date.getSeconds()
    const week = date.getDay()

    if (type == 'date') {
        return [year, month, day].map(formatNumber).join('-')
    } else if (type == 'datetime') {
        return [year, month, day].map(formatNumber).join('-') + ' ' + [hour, minute, second].map(formatNumber).join(':')
    } else if (type == 'week') {
        const weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
        return weeks[week]
    }
}

const formatNumber = n => {
    n = n.toString()
    return n[1] ? n : '0' + n
}

function checkoutName(name) {
    if (name == "" || name == null) {
        return true
    }
    return false
}

function checkoutPhone(phone) {
    if (!/^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(phone)) {
        return true
    }
    return false
}

function checkoutEmail(email) {
    if (!/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/g.test(email)) {
        return true
    }
    return false
}


// 获取当前时间 yyyy-mm-dd
function getNowDate(ch) {
    let date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDate();
    if (month < 10) {
        month = "0" + month;
    }
    if (day < 10) {
        day = "0" + day;
    }
    if (ch == 'ch') {
        return year + "年" + month + "月" + day + '日';
    }
    return year + "-" + month + "-" + day;
}

function monthFirstDay(time) { //获取月份第一天
    let firstDay = new Date(time);
    let date = new Date(firstDay.getFullYear(), firstDay.getMonth(), 1)
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // 月份从0开始计算，需要加1
    let day = date.getDate();

    if (month < 10) {
        month = "0" + month;
    }
    if (day < 10) {
        day = "0" + day;
    }
    return year + "-" + month + "-" + day;
}

function monthLastDay(time) { //获取月份最后一天
    let date = new Date(time);
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // 月份从0开始计算，需要加1
    let lastDay = new Date(year, month, 0).getDate();
    if (month < 10) {
        month = "0" + month;
    }
    if (lastDay < 10) {
        lastDay = "0" + lastDay;
    }
    return year + "-" + month + "-" + lastDay;
}

function weekFirstDay(time) { //获取本周第一天
    let week = new Date(time);
    let weekDay = week.getDay();
    let diff = week.getDate() - weekDay + (weekDay === 0 ? -6 : 1);

    let date = new Date(week.setDate(diff));
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // 月份从0开始计算，需要加1
    let day = date.getDate();

    if (month < 10) {
        month = "0" + month;
    }
    if (day < 10) {
        day = "0" + day;
    }
    return year + "-" + month + "-" + day;
}

function weekLastDay(time) { //获取本周最后一天
    let week = new Date(time);
    let weekDay = week.getDay();
    let diff = week.getDate() + (7 - weekDay) + (weekDay === 0 ? -7 : 0);
    let date = new Date(week.setDate(diff));
    let year = date.getFullYear();
    let month = date.getMonth() + 1; // 月份从0开始计算，需要加1
    let day = date.getDate();

    if (month < 10) {
        month = "0" + month;
    }
    if (day < 10) {
        day = "0" + day;
    }
    return year + "-" + month + "-" + day;
}

/**
 * 数组对象 去重
 * arr 数组  uniId 唯一id
 * */
export function uniqueFunc(arr, uniId) {
    const res = new Map();
    return arr.filter((item) => !res.has(item[uniId]) && res.set(item[uniId], 1));
}

/**
 * 对象数组倒叙
 * */
export function reversePeople(array) {
    let newArr = [];
    for (let i = array.length - 1; i >= 0; i--) {
        newArr[newArr.length] = array[i];
    }
    return newArr;
}

// 深拷贝
function deepCopy(obj) {
    let newObj = null
    if (typeof obj === 'object' && obj !== null) {
        newObj = obj instanceof Array ? [] : {}
        for (let i in obj) {
            newObj[i] = typeof obj[i] === 'object' ? deepCopy(obj[i]) : obj[i]
        }
    } else {
        newObj = obj
    }
    return newObj
}

function unique(arr) {
    let newArr = [arr[0]];
    for (let i = 1; i < arr.length; i++) {
        let repeat = false;
        for (let j = 0; j < newArr.length; j++) {
            if (arr[i] === newArr[j]) {
                repeat = true;
                break;
            } else {

            }
        }
        if (!repeat) {
            newArr.push(arr[i]);
        }
    }
    return newArr;
}

function sizeTostr(size) {
    var data = "";
    if (size < 0.1 * 1024) { //如果小于0.1KB转化成B
        data = size.toFixed(2) + "B";
    } else if (size < 0.1 * 1024 * 1024) {//如果小于0.1MB转化成KB
        data = (size / 1024).toFixed(2) + "KB";
    } else if (size < 0.1 * 1024 * 1024 * 1024) { //如果小于0.1GB转化成MB
        data = (size / (1024 * 1024)).toFixed(2) + "MB";
    } else { //其他转化成GB
        data = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    }
    var sizestr = data + "";
    var len = sizestr.indexOf("\.");
    var dec = sizestr.substr(len + 1, 2);
    if (dec == "00") {//当小数点后为00时 去掉小数部分
        return sizestr.substring(0, len) + sizestr.substr(len + 3, 2);
    }
    return sizestr;
}

export default {
    formatTime: formatTime,
    getQueryString: getQueryString,
    timestampToTime: timestampToTime,
    dateFormat: dateFormat,
    checkoutName: checkoutName,
    checkoutPhone: checkoutPhone,
    checkoutEmail: checkoutEmail,
    // Client:Client,

    getNowDate: getNowDate,
    uniqueFunc: uniqueFunc,
    reversePeople: reversePeople,
    deepCopy: deepCopy,
    unique: unique,
    judgeDataIsEmpty,
    sizeTostr,
    monthFirstDay,
    monthLastDay,
    weekFirstDay,
    weekLastDay
}
